import { api } from "../components/utils/JWTAuth";
import React, { Component } from "react";
import { Row, Col, Container } from "react-grid-system";
import { Link } from "react-router-dom";
import Newsletter from "../components/WidgetsSidebar/newsletter";
import ImageDefault from "../components/img/noticias_default.jpg";
import TopImageTitle from "../components/objects/topImageTitle";
import ButtonFES from "../components/objects/button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as Icons from "@fortawesome/free-solid-svg-icons";
import ReactGA from "react-ga";
import { Divider } from "antd";
import Cookies from "js-cookie";
class EscuelaDoctoradoNotice extends Component {
	state = {
		posts: [],
		prevPost: [],
		nxtPost: [],
		documents: [],
		postID: "",
	};

	componentDidMount() {
		window.scrollTo(0, 0);
		//var url = window.location.href.split("/");
		//var pathurl = "/" + url[4] + "/" + url[5] + "/" + url[6] + "/";
		const permalink = this.props.match.params.permalink;
		const cat = this.props.match.params.cat;
		const id = this.props.match.params.id;
		//fetch(`noticia/${permalink}`);

		let formData = new FormData();

		if (!id) {
			formData.append("permalink", "/" + permalink);
		} else {
			formData.append(
				"permalink",
				"/" + permalink + "/" + cat + "/" + id + "/"
			);
		}

		//formData.append("permalink", pathurl);

		//Call to webservice to get the new
		api.post("/activities_get_by_permalink", formData).then((res) => {
			console.log(res);
			this.setState({
				posts: res.data.records,
				postID: res.data.records[0].id,
				documents: res.data.records[0].docs,
			});

			var prevId = res.data.records[0].id - 1;
			var nextId = +res.data.records[0].id + 1;

			var formDataprev = new FormData();
			formDataprev.append("id", prevId);

			api.post("/activities_get_by_id", formDataprev).then((res) => {
				this.setState({
					prevPost: res.data.records,
				});
			});

			var formDatanext = new FormData();
			formDatanext.append("id", nextId);
			api.post("/activities_get_by_id", formDatanext).then((res) => {
				this.setState({
					nxtPost: res.data.records,
				});
			});
		});
		ReactGA.pageview(window.location.pathname + window.location.search);
	}
	componentDidUpdate(prevProps, prevState, snapshot) {
		window.scrollTo(0, 0);
		//var url = window.location.href.split("/");
		//var pathurl = "/" + url[4] + "/" + url[5] + "/" + url[6] + "/";
		const permalink = this.props.match.params.permalink;
		const cat = this.props.match.params.cat;
		const id = this.props.match.params.id;

		//fetch(`noticia/${permalink}`);
		if (this.props.match.params !== prevProps.match.params) {
			let formData = new FormData();
			if (!id) {
				formData.append("permalink", "/" + permalink);
			} else {
				formData.append(
					"permalink",
					"/" + permalink + "/" + cat + "/" + id + "/"
				);
			}
			//formData.append("permalink", pathurl);

			//Call to webservice to get the new
			api.post("/activities_get_by_permalink", formData).then((res) => {
				//console.log(res);
				this.setState({
					posts: res.data.records,
					postID: res.data.records[0].id,
				});
				var prevId = res.data.records[0].id - 1;
				var nextId = +res.data.records[0].id + 1;
				let formData = new FormData();
				formData.append("id", prevId);
				api.post("/activities_get_by_id", formData).then((res) => {
					this.setState({
						prevPost: res.data.records,
					});
				});

				var formDatanext = new FormData();
				formDatanext.append("id", nextId);
				api.post("/activities_get_by_id", formDatanext).then((res) => {
					this.setState({
						nxtPost: res.data.records,
					});
				});
			});
		}
	}
	componentWillReceiveProps(nextProps) {
		const permalink = this.props.match.params.permalink;
		const cat = this.props.match.params.cat;
		const id = this.props.match.params.id;
		if (nextProps.match.params !== this.props.match.params) {
			window.scrollTo(0, 0);
			let formData = new FormData();
			if (!id) {
				formData.append("permalink", "/" + permalink);
			} else {
				formData.append(
					"permalink",
					"/" + permalink + "/" + cat + "/" + id + "/"
				);
			}
			//formData.append("permalink", pathurl);

			//Call to webservice to get the new
			api.post("/activities_get_by_permalink", formData).then((res) => {
				//console.log(res);
				this.setState({
					posts: res.data.records,
				});
				var prevId = res.data.records[0].id - 1;
				var nextId = +res.data.records[0].id + 1;
				let formData = new FormData();
				formData.append("id", prevId);
				api.post("/activities_get_by_id", formData).then((res) => {
					this.setState({
						prevPost: res.data.records,
					});
				});

				var formDatanext = new FormData();
				formDatanext.append("id", nextId);
				api.post("/activities_get_by_id", formDatanext).then((res) => {
					this.setState({
						nxtPost: res.data.records,
					});
				});
			});
		}
	}
	render() {
		const { posts } = this.state;
		const { documents } = this.state;
		const { prevPost } = this.state;
		const { nxtPost } = this.state;
		let editThisPage;
		if (Cookies.get("isAdmin") === "1") {
			editThisPage = (
				<div>
					<a
						className="button textWhite editEntryButton"
						target="_blank"
						rel="noopener noreferrer"
						href={
							global.urlAdmin + "dashboard/activities/edit/" + this.state.postID
						}
					>
						Editar entrada
					</a>
				</div>
			);
		} else {
			editThisPage = "";
		}

		const title = posts.map((post, index) => {
			return (
				<TopImageTitle
					key={post.id}
					key_id={post.id + index}
					title={post.title}
					cover_image={post.cover_image}
					bread01={post.categories.map((categories) => categories.name)}
				></TopImageTitle>
			);
		});
		const previousPost = prevPost.map((post) => {
			return (
				<Col sm={5} key={post.id}>
					<Link
						to={`/escuela-doctorado${post.permalink}`}
						className="post-prev"
					>
						<p className="m-2 m-lg-0">Anterior Noticia</p>
						<h6 className="text-truncate d-none d-lg-block">{post.title}</h6>
					</Link>
				</Col>
			);
		});
		const nextPost = nxtPost.map((post) => {
			return (
				<Col sm={5} key={post.id}>
					<Link
						to={`/escuela-doctorado${post.permalink}`}
						className="post-next"
					>
						<p className="m-2 m-lg-0">Siguiente Noticia</p>
						<h6 className="text-truncate d-none d-lg-block">{post.title}</h6>
					</Link>
				</Col>
			);
		});
		const notMorePrevPost = (
			<Col sm={5}>
				<Link to="#" className="post-prev">
					<p className="m-2 m-lg-0">No hay más noticias</p>
				</Link>
			</Col>
		);
		const notMorenextPost = (
			<Col sm={5}>
				<Link to="#" className="post-next">
					<p className="m-2 m-lg-0">No hay más noticias</p>
				</Link>
			</Col>
		);
		const defaultImage = posts.map((post) => {
			if (!post.cover_image) {
				return (
					<img
						key={post.id}
						src={ImageDefault}
						alt="a"
						className="blogImage"
					></img>
				);
			} else {
				return (
					<img
						key={post.id}
						src={post.cover_image}
						alt="a"
						className="blogImage"
					></img>
				);
			}
		});

		const notice = posts.map((post) => {
			var date = post.published_date;
			date = date.split(" ")[0];
			var yyyy = date.split("-")[0];
			var mmmm = date.split("-")[1];
			var dddd = date.split("-")[2];
			date = dddd + "-" + mmmm + "-" + yyyy;
			return (
				<Col key={post.id}>
					<div className="inner">
						{defaultImage}
						<span className="categoryNewsTop">
							{post.categories.map((categories, index) => (
								<Link
									className="button"
									key={categories.id + index}
									to={"/categoria-escuela-doctorado/" + categories.id}
								>
									<span>{categories.name}</span>
								</Link>
							))}
						</span>
						<div className="noticeInfo">
							<div>
								<p>{date}</p>
							</div>
						</div>
						<h2>{post.title}</h2>

						<div dangerouslySetInnerHTML={{ __html: post.content }} />
					</div>
					<hr className="separatorNew"></hr>
					<Container>
						<Row className="postNavigation">
							{!prevPost.length ? notMorePrevPost : previousPost}
							<Col sm={2}>
								<Link to={"/historico-escuela-doctorado/"}>
									<i className="fa fa-th allPost"></i>{" "}
								</Link>
							</Col>
							{!nxtPost.length > 0 ? notMorenextPost : nextPost}
						</Row>
					</Container>
				</Col>
			);
		});
		const documentsButtons = documents.map((doc, index) => {
			return (
				<ButtonFES
					button_text={doc.alt}
					button_class="button width-100"
					button_link={doc.doc}
					icon="a"
					key={index}
				></ButtonFES>
			);
		});
		const urlsButtons = posts.map((post, index) => {
			return (
				<div key={index}>
					{post.url3 !== "" ? (
						<div>
							{" "}
							<h5 className="titleSidebar">Inscripción eventos</h5>
							<ButtonFES
								button_text="Inscríbete"
								button_class="button width-100"
								button_link={post.url3}
								key={index}
							></ButtonFES>
						</div>
					) : null}
					{post.url1 !== "" ? (
						<div>
							{" "}
							<h5 className="titleSidebar">Inscripción doctorados</h5>
							<ButtonFES
								button_text="Inscríbete"
								button_class="button width-100"
								button_link={post.url1}
								key={index}
							></ButtonFES>
						</div>
					) : null}
					{post.url2 !== "" ? (
						<div>
							{" "}
							<h5 className="titleSidebar">Inscripción postdoctorados</h5>
							<ButtonFES
								button_text="Inscríbete"
								button_class="button width-100"
								button_link={post.url2}
								key={index}
							></ButtonFES>
						</div>
					) : null}
				</div>
			);
		});

		return (
			<section>
				{title}
				<hr className="whiteSpace"></hr>
				<Container>
					<Row className="lastMinuteNews">
						<Col sm={12}>
							<p>
								<Link
									to="/Actividades/formacion-eventos/escuela-de-doctorado"
									className="goBacklink"
								>
									<FontAwesomeIcon icon={Icons.faArrowLeft} size="1x" /> Volver
									a Escuela de Doctorado
								</Link>
							</p>
						</Col>
						<Col className="sidebar" lg={3} md={3} sm={12}>
							{editThisPage}
							{documents.length > 0 ? (
								<h5 className="titleSidebar">Documentos Relacionados</h5>
							) : null}
							{documentsButtons}
							{documents.length > 0 ? (
								<div>
									<Divider></Divider>
								</div>
							) : null}

							<div>{urlsButtons}</div>
							<Newsletter />
						</Col>
						<Col lg={9} md={9} sm={12}>
							{notice}
						</Col>
					</Row>
				</Container>
			</section>
		);
	}
}

export default EscuelaDoctoradoNotice;
